// extracted by mini-css-extract-plugin
export var bgLoading = "index-module--bg-loading--84987";
export var borderLoading = "index-module--border-loading--bf808";
export var breakBorderLoading = "index-module--break-border-loading--6cefe";
export var gradient = "index-module--gradient--c62d0";